import http from 'axios'
import {formatQuery} from '../../lib/formatParams/index'

export default {
  namespaced: true,
  actions: {
    //获取站点绑定责任人列表
    studentStatic({state}) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/GetStudentStatistics")
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    studentList({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/GetStudentList" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    studentInfo({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/GetStudentInfo" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //获取站点绑定责任人列表
    orderStatic({state}) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/OrderStatistics")
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //获取列表
    orderList({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/GetOrderList" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //获取退款记录列表
    refoundList({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/GetRefoundOrder" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //获取收益
    getIncome({state}) {
      return new Promise((resolve, reject) => {
        http.get("/v1/settleaccount/GetIncomeStatistics")
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //交易统计
    getOrderStatic({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/settleaccount/GetOrderStatistics" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //收益明细
    getIncomeDetail({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/settleaccount/GetIncomeDetail" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //提现明细
    getWithDetail({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/settleaccount/GetWithdrawDetail" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //退款明细
    getRefoundDetail({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/settleaccount/GeRefoundOrderList" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //订单明细
    getPayOrder({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/studentmanger/OrderDetailGetNoPayOrderDetail" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },

    getLingKeOrderList({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetLingKeOrderList" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },

    getExamdaClass({state}, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetExamdaClass" + formatQuery(params))
          .then(({data}) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
  }
}